<template>
    <UPopover v-model:open="isOpen" :dismissible="true" @close="onClosePopover">
        <div v-if="isClosed" class="i-ph-lock-key text-xl" @click="openPeriodClicked" />
        <div v-else class="i-ph-lock-simple-open text-xl" @click="lockPeriodClicked" />
        <template #content>
            <period-lock-dialog
                :period="period"
                :open="lockingPeriod"
                :close="onClosePopover"
            />
        </template>
    </UPopover>
</template>

<script setup lang="ts">
import PeriodLockDialog from '@/period-lock/PeriodLockDialog.vue'
import {computed, ref} from 'vue'
import {Period} from '@/period-lock/periodLock.service'

const props = defineProps({
    params: {
       type: Object,
        required: true
    }
})

const isOpen = ref(false)
const lockingPeriod = ref(false)
const isClosed = computed(() => props.params.isClosed)
const period = computed(() => props.params.period as Period)

const lockPeriodClicked = () => {
    lockingPeriod.value = false
    isOpen.value = true
}

const openPeriodClicked = () => {
    lockingPeriod.value = true
    isOpen.value = true
}

const onClosePopover = () => {
    isOpen.value = false
}

</script>

<style scoped>

</style>